var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('search-dialog-list-item',{attrs:{"icon":"tag","subtitle":_vm.selected.length
      ? _vm.$t('search_and_filter.n_items_selected', {
          count: _vm.selected.length,
          name: ''
        })
      : null,"title":_vm.$t('common.tag', { count: 0 }),"toolbar-title":_vm.$t('common.tag', { count: 0 })}},[(_vm.projectTags)?_c('base-extended-tags-list',{attrs:{"height":"auto","multiple":true,"tag":_vm.selected,"show-any-and-none":true,"tags":Object.values(_vm.projectTags)},on:{"update:tag":function($event){_vm.selected=$event}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }